import { makeStyles } from '@material-ui/core/styles';
import { flexAlignCenterSpaceBetween } from 'UI/utils/styles';

export const useStyles = makeStyles(
  theme => ({
    flexAlignCenterSpaceBetween,
    gaugeChartContainer: {
      position: 'relative',
      paddingTop: theme.spacing(1),
      margin: 'auto'
    },
    gauge: {
      display: 'block',
      width: '100%',
      height: 'auto'
    },
    needle: {
      transformBox: 'view-box',
      transition: 'transform 1s cubic-bezier(0.34, 1.4, 0.64, 1)'
    },
    textCenter: {
      textAlign: 'center'
    }
  }),
  { classNamePrefix: 'gauge-stats' }
);
